import { getEnvironment } from 'vlcishared';

const pentahoServerUrl =
  'https://cdm.vlci.valencia.es/pentaho/api/repos/%3Apublic%3A';
const renderEndpoint = '/generatedContent';
const proLocalFolder = 'sc_valencia%3A';
const preFolder = 'sc_valencia_pre%3A';

function buildLink(env, cdm, view) {
  const folder = env === 'PRO' ? proLocalFolder : preFolder;
  return `${pentahoServerUrl}${folder}${cdm}%3A${view}${renderEndpoint}`;
}

const externalLinks = {
  PRO: {
    pmp: buildLink('PRO', 'GE', 'Menu_GE_PagamentProveidors.wcdf'),
    movilidad_top6: buildLink('PRO', 'Ciutat', 'Vehicles.wcdf'),
    movilidad_emt: buildLink('PRO', 'Ciutat', 'Us_Demt.wcdf'),
    ruido: buildLink('PRO', 'Ciutat', 'Soroll.wcdf'),
    residuos: buildLink('PRO', 'Ciutat', 'Residus.wcdf'),
    reciclaje: buildLink('PRO', 'Ciutat', 'Residus.wcdf'),
    contaminacion_aire: buildLink('PRO', 'Ciutat', 'Contaminacio.wcdf'),
    actividad_admin: buildLink(
      'PRO',
      'GE',
      'Menu_GE-RendimentAdministratiu.wcdf',
    ),
    acceso_sede_electronica: buildLink('PRO', 'Ciutat', 'Seu_Electronica.wcdf'),
    cuadro_ciudad: buildLink('PRO', 'Ciutat', 'Quadre_de_Comandament.wcdf'),
    cuadro_unificado: buildLink('PRO', 'SmartCity', 'Quadre_Unificado.wcdf'),
    cuadro_gestion_economica: buildLink('PRO', 'GE', 'Quadre_de_GE.wcdf'),
    cuadro_movilidad: buildLink('PRO', 'Mobilitat', 'Mobilitat.wcdf'),
    contaminacion_acustica: buildLink('PRO', 'Ciutat', 'Soroll.wcdf'),
    cuadro_alcaldia: buildLink('PRO', 'Alcaldia', 'Inicio.wcdf'),
  },
  PRE: {
    pmp: buildLink('PRE', 'GE', 'Menu_GE_PagamentProveidors.wcdf'),
    movilidad_top6: buildLink('PRE', 'Ciutat', 'Vehicles.wcdf'),
    movilidad_emt: buildLink('PRE', 'Ciutat', 'Us_Demt.wcdf'),
    ruido: buildLink('PRE', 'Ciutat', 'Soroll.wcdf'),
    residuos: buildLink('PRE', 'Ciutat', 'Residus.wcdf'),
    reciclaje: buildLink('PRE', 'Ciutat', 'Residus.wcdf'),
    contaminacion_aire: buildLink('PRE', 'Ciutat', 'Contaminacio.wcdf'),
    actividad_admin: buildLink(
      'PRE',
      'GE',
      'Menu_GE-RendimentAdministratiu.wcdf',
    ),
    acceso_sede_electronica: buildLink('PRE', 'Ciutat', 'Seu_Electronica.wcdf'),
    cuadro_ciudad: buildLink('PRE', 'Ciutat', 'Quadre_de_Comandament.wcdf'),
    cuadro_unificado: buildLink('PRE', 'SmartCity', 'Quadre_Unificado.wcdf'),
    cuadro_gestion_economica: buildLink('PRE', 'GE', 'Quadre_de_GE.wcdf'),
    cuadro_movilidad: buildLink('PRE', 'Mobilitat', 'Mobilitat.wcdf'),
    contaminacion_acustica: buildLink('PRE', 'Ciutat', 'Soroll.wcdf'),
    cuadro_alcaldia: buildLink('PRE', 'Alcaldia', 'Inicio.wcdf'),
  },
};

export function getLink(id) {
  let entorno = getEnvironment();
  if (entorno === 'local') {
    entorno = 'PRE';
  }
  const url = externalLinks[entorno][id];
  return url;
}
